import { CircularProgress, CircularProgressProps } from '@mui/material';
import React from 'react';

export interface SpinnerProps extends Pick<CircularProgressProps, 'size'> {}

export const Spinner: React.FC<SpinnerProps> = ({ size = 24 }) => {
    return <CircularProgress color="secondary" size={size} />;
};
